import { render, staticRenderFns } from "./listing-setup-task-thread.vue?vue&type=template&id=b27da590&"
import script from "./listing-setup-task-thread.vue?vue&type=script&lang=js&"
export * from "./listing-setup-task-thread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports